import { render, staticRenderFns } from "./RestoureIndicatorConfiguration.vue?vue&type=template&id=3fe4b50a&scoped=true&"
import script from "./RestoureIndicatorConfiguration.vue?vue&type=script&lang=js&"
export * from "./RestoureIndicatorConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./RestoureIndicatorConfiguration.vue?vue&type=style&index=0&id=3fe4b50a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe4b50a",
  null
  
)

export default component.exports